<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增活动配置' : '编辑活动配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="230px"
        size="mini"
        style="width: 700px"
      >
        <el-form-item v-if="!this.isCreated" label="ID：" prop="id">
          <el-input style="width: 200px" v-model="form.id" readonly></el-input>
        </el-form-item>
        <el-form-item label="跨服活动：" prop="isGlobal">
          <el-switch v-model="form.isGlobal" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item label="类型：" prop="activityTemplateKey">
          <el-input
            style="width: 150px"
            v-model="form.activityTemplateKey"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间：" prop="startTimeType">
          <el-select
            v-model="form.startTimeType"
            @change="startTimeTypeChange"
            placeholder="请选择"
            style="width: 130px"
          >
            <el-option
              v-for="item in this.param.startTimeTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-if="form.startTimeType == 2"
            style="margin-left: 10px; width: 130px"
            v-model="form.startTime"
            type="date"
            :clearable="false"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <el-input
            v-else
            style="margin-left: 10px; width: 120px"
            v-model="form.startTime"
          ></el-input>
        </el-form-item>

        <el-form-item label="活动持续时长（天）：" prop="keepDays">
          <el-input style="width: 150px" v-model="form.keepDays"></el-input>
        </el-form-item>
        <el-form-item
          v-if="
            startTimeTypeSelectorsMaps[form.startTimeType]
              ? startTimeTypeSelectorsMaps[form.startTimeType]
                  .isAbleSettingCycle
              : false
          "
          label="循环："
          prop="isCycle"
        >
          <el-switch v-model="form.isCycle" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item v-if="form.isCycle" label="循环间隔：" prop="isCycle">
          <el-input
            v-model.number="form.cycleInterval[0]"
            style="width: 80px"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            placeholder="天"
          ></el-input
          >&nbsp;天&nbsp;
          <el-input
            v-model.number="form.cycleInterval[1]"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 80px"
            placeholder="小时"
          ></el-input
          >&nbsp;小时&nbsp;
          <el-input
            v-model.number="form.cycleInterval[2]"
            onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 80px"
            placeholder="分钟"
          ></el-input
          >&nbsp;分钟
        </el-form-item>
        <el-form-item label="玩法类型：" prop="playType">
          <el-select
            v-model="form.playType"
            placeholder="请选择"
            style="width: 130px"
          >
            <el-option
              v-for="item in this.param.playTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.playType == 1"
          label="若时间不够时不开启下一轮："
          prop="isNoNextPlayWhenTimeNotEnough"
        >
          <el-switch
            v-model="form.isNoNextPlayWhenTimeNotEnough"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>

        <el-form-item
          label="玩法相距活动开始时间（分钟）："
          prop="playStartTime"
        >
          <el-input
            style="width: 150px"
            v-model="form.playStartTime"
          ></el-input>
        </el-form-item>
        <el-form-item label="玩法持续时长（分钟）：" prop="playKeepTime">
          <el-input style="width: 150px" v-model="form.playKeepTime"></el-input>
        </el-form-item>

        <el-form-item label="启用：" prop="isEnabled">
          <el-switch
            v-model="form.isEnabled"
            active-color="#13ce66"
          ></el-switch>
        </el-form-item>
        <el-form-item v-if="!form.isEnabled" label="自动启用：">
          <el-switch
            v-model="form.isUseAutoEnabledAfter"
            active-color="#13ce66"
          ></el-switch>
          <el-date-picker
            v-if="form.isUseAutoEnabledAfter"
            v-model="form.autoEnabledAfter"
            type="datetime"
            :clearable="false"
            placeholder="选择时间"
            format="yyyy-MM-dd HH:mm"
            value-format="timestamp"
            style="width: 160px; margin-left: 10px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="子活动集合：" prop="childActivities">
          <div
            v-for="(item, index) of this.form.childActivities"
            :key="item.seq"
          >
            <el-select
              style="margin-bottom: 5px"
              v-model="item.id"
              placeholder="请选择"
              @change="updateavailableConditions"
            >
              <el-option
                v-for="conitionItem in param.childActivities"
                :key="conitionItem.value"
                :label="conitionItem.label"
                :value="conitionItem.value"
              ></el-option>
            </el-select>
            <el-button
              @click="onClickRemoveChildActivity(index)"
              style="margin-left: 10px"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addChildActivity()" class="el-icon-plus"
            >添加子活动</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const luxon = require("luxon");
// 本弹窗名称
const DialogName = "EditActivityConfigDialog";
export default {
  data() {
    return {
      form: {
        isGlobal: false,
        activityTemplateKey: "",
        startTimeType: 2,
        startTime: "",
        keepDays: "",
        playType: 0,
        isNoNextPlayWhenTimeNotEnough: false,
        isEnabled: false,
        isUseAutoEnabledAfter: false,
        autoEnabledAfter: null,
        childActivities: [],
        isCycle: false,
        cycleInterval: [0, 0, 0],
      },
      param: {},
      startTimeTypeSelectorsMaps: {},
      isCreated: false,
    };
  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    this.isCreated = value.isCreated;
    if (!this.isCreated) {
      this.form = value.entry;
      if (this.form.autoEnabledAfter != "0") {
        this.form.isUseAutoEnabledAfter = true;
      }
    }

    await this.loadParam();
    console.log("param", this.param);
  },
  components: {},

  methods: {
    async loadParam() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getActivityConfigParam`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.param = resData.data;

      for (let item of this.param.startTimeTypes) {
        this.startTimeTypeSelectorsMaps[item.value] = item;
      }
    },
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      this.form.activityTemplateKey = this.form.activityTemplateKey.trim();
      if (this.form.activityTemplateKey.length == 0) {
        this.$message({
          message: "活动名称不能为空",
          type: "error",
        });
        return;
      }

      this.form.startTime = this.form.startTime.trim();
      if (this.form.startTime.length == 0) {
        this.$message({
          message: "开始时间不能为空",
          type: "error",
        });
        return;
      }

      let parseResult = util.string2PositiveInt(this.form.keepDays);
      if (parseResult.err) {
        this.$message({
          message: "活动持续时长" + parseResult.err,
          type: "error",
        });
        return;
      }
      this.form.keepDays = parseResult.value;

      if (this.form.childActivities.length == 0) {
        this.$message({
          message: "子活动不能为空",
          type: "error",
        });
        return;
      } else {
        for (let item of this.form.childActivities) {
          if (item.id.trim().length == 0) {
            this.$message({
              message: "子活动的值不能为空",
              type: "error",
            });
            return;
          }
        }
      }

      if (!this.form.isEnabled) {
        if (!this.form.isUseAutoEnabledAfter) {
          this.form.autoEnabledAfter = "0";
        }
      } else {
        this.form.autoEnabledAfter = "0";
      }

      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增活动配置？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addActivityConfig`,
            {
              config: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;

        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "新增成功，大概几秒内会生效",
          type: "success",
        });
        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改活动配置？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/updateActivityConfig`,
            {
              config: this.form,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;

        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功，大概几秒内会生效",
          type: "success",
        });
        // 关闭当前对话框
        this.onClose();
      } catch (e) {}
    },

    async addChildActivity() {
      this.form.childActivities.push({
        id: "",
      });
    },
    async onClickRemoveChildActivity(index) {
      this.form.childActivities.splice(index, 1);
      this.updateavailableConditions();
    },

    async updateavailableConditions() {
      for (let i = 0; i < this.param.childActivities.length; i++) {
        this.param.childActivities[i].used = false;
        for (let j = 0; j < this.form.childActivities.length; j++) {
          if (
            this.param.childActivities[i].value ==
            this.form.childActivities[j].id
          ) {
            this.param.childActivities[i].used = true;
            break;
          }
        }
      }
    },

    async startTimeTypeChange(e) {
      this.form.startTime = "";
      this.form.isCycle = false;
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

